import { createContext, useContext, useState, useCallback, type ReactNode } from "react"

interface VerticalContextValue {
  vertical: string | null
  setVertical: (v: string | null) => void
}

const VerticalContext = createContext<VerticalContextValue>({
  vertical: null,
  setVertical: () => {},
})

export function VerticalProvider({ children }: { children: ReactNode }) {
  const [vertical, setVerticalState] = useState<string | null>(() => {
    try {
      return localStorage.getItem("uvx_vertical") || null
    } catch {
      return null
    }
  })

  const setVertical = useCallback((v: string | null) => {
    setVerticalState(v)
    try {
      if (v) {
        localStorage.setItem("uvx_vertical", v)
      } else {
        localStorage.removeItem("uvx_vertical")
      }
    } catch {
      // ignore
    }
  }, [])

  return (
    <VerticalContext.Provider value={{ vertical, setVertical }}>
      {children}
    </VerticalContext.Provider>
  )
}

export function useVertical() {
  return useContext(VerticalContext)
}
